(function () {
  'use strict';

  var STORAGE_KEY = 'collection-grid-switch';
  var TARGET_CLASS_PREFIX = 'GridSwitchTarget--';
  var DEFAULT_MODE = '4';
  var currentMode = DEFAULT_MODE;

  function isValid(mode) {
    return mode === '4' || mode === '2';
  }

  function readStoredMode() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      return isValid(stored) ? stored : null;
    } catch (e) {
      return null;
    }
  }

  function persistMode(mode) {
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      /* storage unavailable, ignore */
    }
  }

  // Apply the active mode to every grid container and sync the switch buttons.
  function syncDom() {
    var targets = document.querySelectorAll('.GridSwitchTarget');
    for (var i = 0; i < targets.length; i++) {
      var target = targets[i];
      target.classList.remove(TARGET_CLASS_PREFIX + '4', TARGET_CLASS_PREFIX + '2');
      target.classList.add(TARGET_CLASS_PREFIX + currentMode);
    }

    var items = document.querySelectorAll('[data-grid-switch] .CollectionGridSwitch__Item');
    for (var j = 0; j < items.length; j++) {
      var item = items[j];
      var isActive = item.getAttribute('data-grid-switch-value') === currentMode;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  }

  function init() {
    if (!document.querySelector('[data-grid-switch]')) return;

    var stored = readStoredMode();
    if (stored) currentMode = stored;
    syncDom();

    // Event delegation survives AJAX re-renders of the grid/toolbar.
    document.addEventListener('click', function (event) {
      var item = event.target.closest && event.target.closest('.CollectionGridSwitch__Item');
      if (!item) return;
      var mode = item.getAttribute('data-grid-switch-value');
      if (!isValid(mode)) return;

      currentMode = mode;
      persistMode(mode);
      syncDom();
    });

    // Re-apply the selected mode after the filter/sort AJAX replaces the
    // collection content (which re-renders the switch buttons as default).
    var content = document.querySelector('.FilterProducts__Content');
    if (content && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        syncDom();
      });
      observer.observe(content, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
